import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostBinding, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { NzInputModule } from 'ng-zorro-antd/input';

import { UiPlatformTextAreaAutosize } from './textarea.model';

type Value = unknown;

@Component({
  selector: 'ui-platform-textarea',
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    NzInputModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPlatformTextareaComponent),
      multi: true
    }
  ]
})
export class UiPlatformTextareaComponent {
  @Input() label = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() autosize: boolean | UiPlatformTextAreaAutosize = true;

  @HostBinding('class.content-bold') @Input() isContentBold = false;
  @HostBinding('class.drawer') @Input() drawer = false;
  @HostBinding('class.inline') @Input() inline = false;

  internalValue: Value = null;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  syncExternalValue: (value: Value) => void = () => {};
  syncExternalTouched: () => void = () => {};

  onModelChange(value: Value) {
    this.syncExternalValue(value);
    this.syncExternalTouched();
  }

  writeValue(value: Value) {
    this.internalValue = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: Value) => void) {
    this.syncExternalValue = (value: Value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.syncExternalTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }
}
